import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    tiposDoc: [
        {
            value: "cedula",
            text: "Cédula de ciudadanía"
        },
        {
            value: "cedula_extranjeria",
            text: "Cédula de extranjeria"
        },
        {
            value: "nit",
            text: "NIT"
        },
        {
            value: "pasaporte",
            text: "Pasaporte"
        },
        {
            value: "tarjeta_identidad",
            text: "Tarjeta de identidad"
        },
    ],
    sedes: []
};
const mutations = {
    updateField,
    getSedes: (state, payload) => {
        state.sedes = payload;
    },

};
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
